import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118f4758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本文", -1))
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "設問", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, "[" + _toDisplayString(_ctx.qa.title) + "]", 1),
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.qa.article), 1),
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qa.q, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "question",
        key: index
      }, [
        _hoisted_5,
        _createElementVNode("p", null, _toDisplayString(item.head), 1),
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.choices.choice, (ch, i) => {
            return (_openBlock(), _createElementBlock("span", { key: i }, "(" + _toDisplayString(i+1) + ") " + _toDisplayString(ch), 1))
          }), 128))
        ]),
        _createElementVNode("p", null, "解答：" + _toDisplayString(item.a), 1),
        _createElementVNode("p", null, "解説：" + _toDisplayString(item.ex), 1),
        (item.complexity_score)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "英文の複雑さのスコア: " + _toDisplayString(item.complexity_score), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}